import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { FaCheckCircle, FaCalendarAlt, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import './PaymentConfirmationPage.css';

const PaymentConfirmationPage = () => {
    const location = useLocation();
    const { event, selectedSeats, totalAmount, paymentDetails } = location.state || {};

    if (!location.state || !paymentDetails) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="confirmation-page">
            <div className="confirmation-container">
                <div className="success-message">
                    <FaCheckCircle className="success-icon" />
                    <h1>Ödeme Başarılı!</h1>
                    <p className="confirmation-email">
                        Biletleriniz <span>{paymentDetails.email}</span> adresine gönderildi.
                    </p>
                </div>

                <div className="order-details">
                    <div className="event-info">
                        <h2>{event?.title}</h2>
                        <div className="event-meta">
                            <p><FaCalendarAlt /> {event?.date}</p>
                            <p><FaClock /> {event?.time}</p>
                            <p><FaMapMarkerAlt /> {event?.location?.venue ? `${event.location.venue}${event.location.city ? `, ${event.location.city}` : ''}` : 'Konum bilgisi mevcut değil'}</p>
                        </div>
                    </div>

                    <div className="tickets-info">
                        <h3>Bilet Detayları</h3>
                        <div className="tickets-grid">
                            {selectedSeats?.map((seat, index) => (
                                <div key={index} className="ticket-item">
                                    <div className="seat-info">
                                        <span className="seat-label">Koltuk {seat.label}</span>
                                        <span className="seat-category">{seat.category}</span>
                                    </div>
                                    <span className="seat-price">{seat.price} TL</span>
                                </div>
                            ))}
                        </div>
                        <div className="total-amount">
                            <span>Toplam Tutar</span>
                            <span>{totalAmount} TL</span>
                        </div>
                    </div>

                    <div className="contact-info">
                        <h3>İletişim Bilgileri</h3>
                        <div className="contact-grid">
                            <div className="contact-item">
                                <span className="label">Ad Soyad:</span>
                                <span className="value">{paymentDetails.name}</span>
                            </div>
                            <div className="contact-item">
                                <span className="label">E-posta:</span>
                                <span className="value">{paymentDetails.email}</span>
                            </div>
                            <div className="contact-item">
                                <span className="label">Telefon:</span>
                                <span className="value">{paymentDetails.phone}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentConfirmationPage; 